import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../header/header.component';
import { FullLayoutComponent } from '../full-layout/full-layout.component';

@Component({
  selector: 'fly-auth-layout',
  imports: [HeaderComponent, RouterOutlet],
  templateUrl: './auth-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent extends FullLayoutComponent {}
